import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login";
import { RegisterListComponent } from "./register_list";
import { RegisterViewComponent } from "./register_view";
import { EventViewComponent } from "./event_view";
import { UploadExcelComponent } from "./upload_excel";
import { AuthSuperadminGuard, AuthVendorGuard } from "./_guards";
import { SiteHeaderComponent } from "./_layouts/site-header/site-header.component";
import { EditComponent } from "./edit";
import { CategoryEditComponent } from "./category_edit";
import { CategoryAddComponent } from "./category_add";
import { InstitutionAddComponent } from "./institution_add";
import { InstitutionEditComponent } from "./institution_edit";

import { CreatePaymentComponent } from "./create_payment";
import { EditQuickPayCategoryComponent } from "./edit_quickpay_category";

import { PaymentListComponent } from "./payment_list";
import { QuickPayPaymentListComponent } from "./quickpay_payment_list";

import { CategoryListComponent } from "./category_list";
import { QuickPayCategoryListComponent } from "./quickpay_category_list";
import { InstitutionListComponent } from "./institution_list";
import { StudentUserListComponent } from "./student_user_list";
import { StudentUserList2Component } from "./student_user_list2";
import { StaffUserListComponent } from "./staff_user_list";

import { PaymentViewComponent } from "./payment_view";
import { QuickPayPaymentViewComponent } from "./quickpay_payment_view";
import { CategoryViewComponent } from "./category_view";

import { AdhocdetailsComponent } from "./adhoc-details";
import { BulkMailComponent } from "./bulk_mail";
import { AdhoclistComponent } from "./adhoclist";

import { HackathonComponent } from "./hackathon";
import { AlmashineRegistrationListComponent } from "./almashine-registration-list/almashine-registration-list.component";
import { PhdListComponent } from "./phd-list/phd-list.component";
import { ConferenceListComponent } from "./conference-list/conference-list.component";
import { TmaPaiRegListComponent } from "./tmapai_reg_list/tmapai_reg_list.component";
import { ChessEventComponent } from "./chess_event/chess_event.component";
import { ConferenceRegistrationListComponent } from "./conference-registration-list/conference-registration-list.component";
import { KalaFestComponent } from "./kala_fest/kala_fest.component";
import { IqacMitComponent } from "./iqac-mit/iqac-mit.component";
import { TdwfeComponent } from "./tdwfe/tdwfe.component";
import { ConstructionLawComponent } from "./construction-law/construction-law.component";
import { AdhikshanaRegisterListComponent } from "./adhikshana-register-list/adhikshana-register-list.component";
import { ErayaRegistrationComponent } from "./eraya-registration/eraya-registration.component";
import { MujoRegListComponent } from "./mujo-reg-list/mujo-reg-list.component";
import { TechSolsticeNexusComponent } from "./tech-solstice-nexus/tech-solstice-nexus.component";
import { AgileDevopsReglistComponent } from "./agile-devops-reglist/agile-devops-reglist.component";
import { ConferenceComponent } from "./conference/conference.component";
import { MaheHostelsRegListComponent } from "./mahe-hostels-reg-list/mahe-hostels-reg-list.component";
import { DaycareRegListComponent } from "./daycare-reg-list/daycare-reg-list.component";
import { BasketballRegListComponent } from "./basketball-reg-list/basketball-reg-list.component";
import { ReflektaComponent } from "./reflekta/reflekta.component";
import { AleyComponent } from "./aley/aley.component";
import { CinaComponent } from "./cina/cina.component";
import { VehicleRegListComponent } from "./vehicle-reg-list/vehicle-reg-list.component";
import { BazzarMicRegListComponent } from "./bazzar-mic-reg-list/bazzar-mic-reg-list.component";
import { CricketRegListComponent } from "./cricket-reg-list/cricket-reg-list.component";
import { TessellateRegListComponent } from "./tessellate-reg-list/tessellate-reg-list.component";
import { FdpRegListComponent } from "./fdp-reg-list/fdp-reg-list.component";
import { GalaRegListComponent } from "./gala-reg-list/gala-reg-list.component";
import { KennyRegListComponent } from "./kenny-reg-list/kenny-reg-list.component";
import { PopconRegListComponent } from "./popcon-reg-list/popcon-reg-list.component";
import { SustainRegListComponent } from "./sustain-reg-list/sustain-reg-list.component";
import { HackniteRegListComponent } from "./hacknite-reg-list/hacknite-reg-list.component";
import { ArbitrationWorkshopComponent } from "./arbitration-workshop/arbitration-workshop.component";
import { ErayaRegistration2025Component } from "./eraya-registration2025/eraya-registration2025.component";
import { XenoraListComponent } from "./xenora-list/xenora-list.component";
import { IeeeRegistrationComponent } from "./ieee-registration/ieee-registration.component";
import { CommerciumListComponent } from "./commercium-list/commercium-list.component";
import { RmsListComponent } from "./rms-list/rms-list.component";
const appRoutes: Routes = [
  {
    path: "",
    component: HomeComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "bulk-mail",
    component: BulkMailComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "createdetails",
    component: AdhocdetailsComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "adhoclist",
    component: AdhoclistComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "registration-list",
    component: RegisterListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "almashine-registration-lists",
    component: AlmashineRegistrationListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "category-list",
    component: CategoryListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "quickpay-category-list",
    component: QuickPayCategoryListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "institution-list",
    component: InstitutionListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "student-user-list",
    component: StudentUserListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "student-user-list2",
    component: StudentUserList2Component,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "staff-user-list",
    component: StaffUserListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "phd-list",
    component: PhdListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "tmapai_reg_list",
    component: TmaPaiRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "chess_event",
    component: ChessEventComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "iqac-mit",
    component: IqacMitComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "TDWFE",
    component: TdwfeComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "Adhikshana",
    component: AdhikshanaRegisterListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "Falak",
    component: ErayaRegistrationComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "eraya",
    component: ErayaRegistration2025Component,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "basketbal-reg-list",
    component: BasketballRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "Mujo",
    component: MujoRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "Tech-Solstice-Nexus",
    component: TechSolsticeNexusComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "IEEE-Registration",
    component: IeeeRegistrationComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "faculty-reg-list",
    component: AgileDevopsReglistComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "reflekta-reg-list",
    component: ReflektaComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "aley-reg-list",
    component: AleyComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "cina-reg-list",
    component: CinaComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "vehicle-reg-list",
    component: VehicleRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "conference-reg-list",
    component: ConferenceComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "bazaar-mic-reg-list",
    component: BazzarMicRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "cricket-reg-list",
    component: CricketRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "tessellate-reg-list",
    component: TessellateRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "fdp-reg-list",
    component: FdpRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "gala-reg-list",
    component: GalaRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "kenny-reg-list",
    component: KennyRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "popcon-reg-list",
    component: PopconRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "sustain-reg-list",
    component: SustainRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "hacknite-reg-list",
    component: HackniteRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "arbitration-workshop-reg-list",
    component: ArbitrationWorkshopComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "xenora-list",
    component: XenoraListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "ieee-list",
    component: IeeeRegistrationComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "commercium-list",
    component: CommerciumListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "rms-list",
    component: RmsListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "mahe-hostel-reg-list",
    component: MaheHostelsRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "Construction-Law-blr",
    component: ConstructionLawComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "kala_fest",
    component: KalaFestComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
  },
  {
    path: "payment-list",
    component: PaymentListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "conference-list",
    component: ConferenceListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "conference-registration-list",
    component: ConferenceRegistrationListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "quickpay-payment-list",
    component: QuickPayPaymentListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "payment-view/:id",
    component: PaymentViewComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "quickpay-payment-view/:id",
    component: QuickPayPaymentViewComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "category-view/:id",
    component: CategoryViewComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "edit/:id",
    component: EditComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "category-edit/:id",
    component: CategoryEditComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "category-add",
    component: CategoryAddComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "institution-add",
    component: InstitutionAddComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "coursera-dashboard",
    component: HomeComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "almashine-dashboard",
    component: HomeComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "coursera-registration-lists",
    component: AlmashineRegistrationListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "coursera-payment-list",
    component: PaymentListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "daycare-reg-list",
    component: DaycareRegListComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "institution-edit/:id",
    component: InstitutionEditComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "create-payment",
    component: CreatePaymentComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "edit-quickpayment-category/:id",
    component: EditQuickPayCategoryComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },
  {
    path: "upload-excel",
    component: UploadExcelComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "registration-view/:id",
    component: RegisterViewComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "event-view/:id",
    component: EventViewComponent,
    children: [
      {
        path: "",
        component: SiteHeaderComponent,
        pathMatch: "full",
      },
    ],
    canActivate: [AuthSuperadminGuard],
  },

  {
    path: "login",
    component: LoginComponent,
  },

  {
    path: "dedalus_mental_health_hackathon",
    component: HackathonComponent,
  },

  // otherwise redirect to home
  {
    path: "**",
    redirectTo: "",
  },
];

export const routing = RouterModule.forRoot(appRoutes);
